module.exports = __webpack_public_path__ + "img/czf_lct@2x.d84dc30b.png";